import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Field, Form, Formik, getIn, useFormikContext } from "formik";
import FormRadioGroup from "./lib/formik/RadioGroup";
import FormTextInput from "./lib/formik/InputField";
import * as Yup from "yup";
import {
  getAgentDetails,
  saveServiceCharges,
  sendSubContributionEmail,
} from "../../../../store/actions";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import Signbutton from "../../../forms/button";
import Image from "../../../Image";

const BUILD_URL = process.env.PUBLIC_URL;

const labelText = {
  fontWeight: 400,
  fontSize: "14px",
  fontFamily: `'Roboto', sans-serif`,
  color: "#002856",
};

const Additionalpurchase = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state) => state.authReducer.token);
  const subscriber = useSelector((state) => state.newSubscriber.subscriberData);
  const { PAN } = useSelector((state) => state.profileReducer.profileData);
  const ref = useRef();
  const [agentRefNumber, setAgentRefNumber] = useState("");
  const [agentData, setAgentData] = useState("");
  const [serviceCharges, setServiceCharges] = useState("");
  const initialValues = {
    accountType: subscriber?.AccountType,
    type: "1",
    pensionFundManager: "",
    amount: "",
    invOption: "",
  };

  const validationSchema = Yup.object().shape({
    amount: Yup.number()
      .required("Lumpsum Amount is required")
      .when("accountType", {
        is: "2",
        then: Yup.number().min(
          250,
          "Lumpsum amount should be greater than 250."
        ),
        otherwise: Yup.number().min(
          500,
          "Lumpsum amount should be greater than 500."
        ),
      })
      .max(1000000000, "Lumpsum Amount should be less than 1,00,00,00,000."),
  });

  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const copyUrl = () => {
    navigator.clipboard.writeText(url);
    alert("URL copied to clipboard");
  };
  const closeModal = () => {
    history.push("/");
  };

  useEffect(() => {
    if (props.history.location.state.AckNumber) {
      const arn = token.replace("ARN-", "");
      const diff = 8 - arn.length;
      const pad = "0".repeat(diff);
      setAgentRefNumber(PAN + pad + arn);
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      const response = await dispatch(
        getAgentDetails({
          agentRefNumber: agentRefNumber,
        })
      );
      console.log(response.data);
      setAgentData(response?.data);

      if (ref.current) {
        ref.current.setFieldValue(
          "pensionFundManager",
          response?.data?.TPI_ClientName
        );
        ref.current.setFieldValue("accountType", subscriber?.AccountType);
      }
    }

    if (agentRefNumber) {
      fetchData();
    }
  }, [agentRefNumber]);

  const fetchServiceData = async (amount) => {
    const params = {
      AccountType: Number(subscriber?.AccountType),
      Amount: Number(amount),
      PranNo: subscriber?.PRAN,
      POP_SPCode: agentData?.POP_SPCode,
    };

    const response = await dispatch(saveServiceCharges(params));
    setServiceCharges(response?.data);
    console.log(response);
  };

  const _handleSubmit = async (values) => {
    // console.log(values);
    try {
      const params = {
        Pran: subscriber?.PRAN,
        ContributionType: "S",
        AccounType: Number(subscriber?.AccountType),
        TotalAmount: Number(values?.amount),
        POP_Code: agentData?.POPCode,
        POP_SP_Code: agentData?.POP_SPCode,
        AgentReferenceNumber: agentRefNumber,
        EmailID: subscriber?.EmailID,
        PhoneNumber: subscriber?.PhoneNumber,
        PAN: subscriber?.PAN,
        SubscriberName: subscriber?.SubscriberName,
      };
      const response = await dispatch(sendSubContributionEmail(params));
      setUrl(response?.data?.tinyUrl);
      setOpen(true);
    } catch (error) {
      alert(error);
      console.error(error);
    }
  };

  return (
    <div className="container-margin" style={{ marginTop: "3%" }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: "20%" }}>
          <div
            style={{
              width: "100%",
              height: "75px",
              background: "rgba(0, 124, 197, 0.1034)",
              borderRadius: "5px",
              textAlign: "center",
              display:'flex'
            }}
          >
            <img
                      alt="user"
                      src={`${BUILD_URL}/images/user.png`}
                      width="40"
                      height="40"
                      className="user-icon"
                      style={{margin:'12px 10px 10px 12px'}}
                    />
                    <div>
            <div
              style={{
                color: "#007CC5",
                fontSize: "16px",
                fontWeight: 400,
                fontFamily: "sans-serif",
                paddingTop: "12px",
              }}
            >
              
              {subscriber?.SubscriberName}
            </div>
            <div
              style={{
                color: "#111111",
                fontSize: "13px",
                fontWeight: 400,
                fontFamily: "sans-serif",
              }}
            >
              PRAN: {subscriber?.PRAN}
            </div></div>
          </div>
        </div>
        <div
          style={{
            marginLeft: "20px",
            paddingLeft: "8%",
            width: "80%",
            height: "100%",
            paddingRight: "10%",
            borderLeft: "1px solid #AAAAAA",
          }}
        >
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            innerRef={ref}
            onSubmit={_handleSubmit}
          >
            {({ values, handleChange, errors, setFieldValue }) => (
              <Form>
                <div
                  style={{
                    color: "#111111",
                    fontSize: "18px",
                    fontWeight: 400,
                    fontFamily: "sans-serif",
                    margin: "10px 10px",
                    paddingLeft: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  Additional Purchase
                </div>
                <FormRadioGroup
                  label="Select Account Type"
                  name="accountType"
                  options={[
                    { label: "Tier I", value: "1" },
                    { label: "Tier II", value: "2" },
                  ]}
                  fullWidth={true}
                  disabled={true}
                />
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginLeft: "10px",
                    paddingLeft: "10px",
                    paddingBottom: "12px",
                  }}
                >
                  Lumpsum
                </div>

                {/* <FormRadioGroup
                  name="type"
                  options={[{ label: "Lumpsum", value: "1" }]}
                /> */}
                <FormTextInput
                  label="Pension Funds Manager"
                  name={`pensionFundManager`}
                  disabled
                  fullWidth={true}
                />
                <FormTextInput
                  label="Lumpsum Amount"
                  name="amount"
                  type="number"
                  onChange={async (e) => {
                    const value = +e.target.value;
                    setFieldValue("amount", value == 0 ? "" : "" + value);
                    if (subscriber?.AccountType == "2") {
                      if (Number(value) >= 250) {
                        await fetchServiceData(value);
                        return;
                      }
                    } else {
                      if (Number(value) >= 500) {
                        await fetchServiceData(value);
                        return;
                      }
                    }
                  }}
                  placeholder={
                    subscriber?.AccountType == "2"
                      ? `Minimum Amount ₹.250`
                      : `Minimum Amount ₹.500`
                  }
                  required
                />
                {/* <FormRadioGroup
                  label="Investment Options"
                  name={`invOption`}
                  options={INVESTMENT_OPTIONS}
                  required
                /> */}
                {serviceCharges && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "15px",
                      marginBottom: "0px",
                    }}
                    className="container-margin"
                  >
                    <div>
                      <p style={labelText}>Service Charge</p>
                      {/* <p style={labelText}>Service Tax</p> */}
                      <p style={labelText}>CGST Amount</p>
                      <p style={labelText}>IGST Amount</p>
                      <p style={labelText}>SGST Amount </p>

                      <p style={labelText}>Total Contribution Amount</p>
                      <p style={labelText}>POP Charges</p>
                      <p style={labelText}>Total Amount Payable</p>
                    </div>
                    <div>
                      <p>₹ {serviceCharges?.Servicecharge}</p>
                      {/* <p>₹ {serviceCharges?.ServiceTax}</p> */}
                      <p>₹ {serviceCharges?.CGSTAmount}</p>
                      <p>₹ {serviceCharges?.IGSTAmount}</p>
                      <p>₹ {serviceCharges?.SGSTAmount}</p>
                      <p>₹ {serviceCharges?.Totalcontributionamount}</p>
                      <p>₹ {serviceCharges?.POPCharges}</p>
                      <p>₹ {serviceCharges?.TotalAmountPayble}</p>
                    </div>
                  </div>
                )}
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    className="new-investor-button new-investor-active"
                    style={{ width: "30%" }}
                    // disabled={Number(values.amount) < 500}
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <CustomizedDialogs
        open={open}
        closeModal={closeModal}
        copyUrl={copyUrl}
      />
    </div>
  );
};

export default Additionalpurchase;

class CustomizedDialogs extends React.Component {
  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.closeModal}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.props.closeModal}
          />
          <DialogContent>
            <div className="modal-content-div">
              <Image
                src={"/images/tick.png"}
                style={{ width: 100, height: 100 }}
                alt="tick"
              />
            </div>

            <div>
              <div className="modal-text-container">
                <div className="modal-text">
                  Your investor will receive the confirmation details and
                  verification link via an email and sms
                </div>
              </div>
            </div>
            <div
              style={{
                fontFamily: "OpenSans-SemiBold",
                fontSize: 16,
                textAlign: "center",
              }}
            >
              Would you like to copy the confirmation link ?
            </div>
            <div className="modal-continue-button">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="dual-margin">
                  <Signbutton
                    buttontitle="Copy"
                    onClick={this.props.copyUrl}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
                <div className="dual-margin">
                  <Signbutton
                    buttontitle="Close"
                    onClick={this.props.closeModal}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
